import { formatDate, formatNumber } from "./formatters.ts";
import type { AdminDuplicatePair, AdminImportBatch } from "./types.ts";

export function ImportBatchesList({
  imports,
  loading,
}: {
  imports: AdminImportBatch[];
  loading: boolean;
}) {
  return (
    <section className="admin-section">
      <div className="admin-section-head">
        <h2>Importações</h2>
        <span>{imports.length}</span>
      </div>
      <div className="admin-list">
        {imports.slice(0, 6).map((batch) => (
          <article className="admin-list-item" key={batch.id}>
            <strong>{batch.import_tag || batch.filename}</strong>
            <span>{batch.status} · {formatNumber(batch.assigned_count)} atribuídos · {formatNumber(batch.pending_count)} pendentes</span>
            <small>{formatDate(batch.created_at)}</small>
          </article>
        ))}
        {!imports.length ? <div className="admin-muted">{loading ? "Carregando..." : "Nenhuma importação encontrada."}</div> : null}
      </div>
    </section>
  );
}

export function DuplicatesList({
  duplicates,
  loading,
}: {
  duplicates: AdminDuplicatePair[];
  loading: boolean;
}) {
  return (
    <section className="admin-section">
      <div className="admin-section-head">
        <h2>Duplicatas</h2>
        <span>{duplicates.length}</span>
      </div>
      <div className="admin-list">
        {duplicates.slice(0, 5).map((item, index) => (
          <article className="admin-list-item" key={`${item.user_email || "user"}-${index}`}>
            <strong>{item.real_name || item.phantom_name || item.phone || item.email || "Lead sem nome"}</strong>
            <span>{item.user_email || "Vendedor não informado"}</span>
            <small>{item.reason || "Possível duplicata"}</small>
          </article>
        ))}
        {!duplicates.length ? <div className="admin-muted">{loading ? "Carregando..." : "Nenhuma duplicata pendente."}</div> : null}
      </div>
    </section>
  );
}
